var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExgange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3852 20L14 15.245L11.0297 15.2447V10.9054V10.8231V6.82476H7.74052V10.8234V15.2447L4.76974 15.245L9.3852 20ZM4.61529 0L9.22993 4.75497L6.25965 4.75529V9.09458V9.17677V13.1752H2.97061V9.17661V4.75529L0 4.75497L4.61529 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExgange);
export default __webpack_public_path__ + "static/media/exgange.da68f1223f65df2514c0ce593529cade.svg";
export { ForwardRef as ReactComponent };